import { Box } from '@mui/material'
import Image from 'next/image'

import {
  Container,
  Context,
  Title,
  Subtitle,
  Pills,
  Pill,
  PillText,
  TechStacks,
  Tech,
  TechLogo,
  TechName,
} from './styled'
import Testimonial from './Testimonial'

export default function ProjectContextSection({ project }: IProjectContextSectionProps) {
  return (
    <Container sx={{ marginBottom: 10 }}>
      <Subtitle>Problem and Project</Subtitle>
      <Title>Context</Title>
      <Box component="div" mb={4}>
        {project?.description?.split('\n').map((text, index) => (
          <Context key={index}>{text === '\r' ? <br /> : text}</Context>
        ))}
      </Box>
      <Pills>
        {project?.services.map((service, index) => (
          <Pill key={index}>
            {service.icon && (
              <Box
                component="div"
                sx={{
                  width: 24,
                  height: 24,
                  position: 'relative',
                }}
              >
                {' '}
                <Image
                  src={service.icon.fullSize}
                  alt={service.iconAltText}
                  layout="fill"
                  objectFit="contain"
                />
              </Box>
            )}
            <PillText>{service.name}</PillText>
          </Pill>
        ))}
      </Pills>
      <TechStacks>
        {project?.techStack.map((tech, index) => (
          <Tech key={index}>
            <TechLogo>
              <Image
                src={tech.logo.fullSize}
                alt={tech.logoAltText || ''}
                layout="fill"
                objectFit="contain"
              />
            </TechLogo>
            <TechName>{tech.name}</TechName>
          </Tech>
        ))}
      </TechStacks>
      {project?.testimonial && <Testimonial testimonial={project?.testimonial} />}
    </Container>
  )
}
